import { useSelector } from "react-redux";
import { checkCRUDAccess } from "utils/crudSagaHelper";


export function useCRUDAccess() {
  const user = useSelector(state => state.auth.user);
  const moduleRights = useSelector(state => state.auth.modules);
  return (moduleId, actions, returnObject = false) => checkCRUDAccess(moduleRights, moduleId, actions, user, returnObject);
}

export default useCRUDAccess;
